import React from "react";
import { TextLink, textLinkTypography } from "@streeteasy/design-system";
import { string } from "prop-types";

import * as S from "./styled";

const TermsMessage = ({ className }) => (
  <div className={className}>
    <S.Text>
      By pressing Send Message, you agree that StreetEasy and real estate
      professionals may call/text you about your inquiry, which may involve use
      of automated means and prerecorded/artificial voices. You don&apos;t need
      to consent as a condition of buying any property, goods or services.
      Message/data rates may apply.
    </S.Text>
    <S.Text>
      You also agree to our{" "}
      <TextLink
        href="//www.zillow.com/corp/Terms.htm"
        target="_blank"
        typography={textLinkTypography.CAPTION}
      >
        Terms of Use
      </TextLink>
      .
    </S.Text>
  </div>
);

TermsMessage.propTypes = {
  className: string
};

TermsMessage.defaultProps = {
  className: null
};

export default TermsMessage;
